import { __read } from "tslib";
import * as u from '@virtuoso.dev/urx';
import { domIOSystem } from './domIOSystem';
import { listStateSystem } from './listStateSystem';
export var totalListHeightSystem = u.system(function (_a) {
    var _b = __read(_a, 2), _c = _b[0], footerHeight = _c.footerHeight, headerHeight = _c.headerHeight, listState = _b[1].listState;
    var totalListHeightChanged = u.stream();
    var totalListHeight = u.statefulStreamFromEmitter(u.pipe(u.combineLatest(footerHeight, headerHeight, listState), u.map(function (_a) {
        var _b = __read(_a, 3), footerHeight = _b[0], headerHeight = _b[1], listState = _b[2];
        // FIXME: this footerHeight, headerHeight calculate is not correct, should find where to apply totalListHeightSystem
        // console.log('-------- [totalListHeightSystem Log] --------');
        // console.log(footerHeight, headerHeight, listState);
        // console.log('---------------- [Log End] ----------------');
        return (footerHeight +
            headerHeight +
            listState.offsetBottom +
            listState.bottom);
    })), 0);
    u.connect(u.duc(totalListHeight), totalListHeightChanged);
    return { totalListHeight: totalListHeight, totalListHeightChanged: totalListHeightChanged };
}, u.tup(domIOSystem, listStateSystem), { singleton: true });
